// Multi-country states/regions data
export const statesByCountry = {
  // Malaysia - existing data
  MY: [
    {
      label: "Selangor",
      value: "Selangor",
      coord: "3.066695996,101.5499977",
    },
    {
      label: "Kuala Lumpur",
      value: "Kuala Lumpur",
      coord: "3.166665872,101.6999833",
    },
    {
      label: "Melaka",
      value: "Melaka",
      coord: "2.206414407,102.2464615",
    },
    {
      label: "Putrajaya",
      value: "Putrajaya",
      coord: "2.914019795,101.701947",
    },
    {
      label: "Johor",
      value: "Johor",
      coord: "2.033737609,102.566597",
    },
    {
      label: "Kedah",
      value: "Kedah",
      coord: "5.649718444,100.4793343",
    },
    {
      label: "Kelantan",
      value: "Kelantan",
      coord: "5.333351285,101.9998241",
    },
    {
      label: "Negeri Sembilan",
      value: "Negeri Sembilan",
      coord: "2.72581,102.251099",
    },
    {
      label: "Pahang",
      value: "Pahang",
      coord: "3.710520521,102.5341149",
    },
    {
      label: "Perak",
      value: "Perak",
      coord: "4.664035542,101.0649813",
    },
    {
      label: "Perlis",
      value: "Perlis",
      coord: "6.443589,100.216599",
    },
    {
      label: "Pulau Pinang",
      value: "Pulau Pinang",
      coord: "5.355014241,100.3014203",
    },
    {
      label: "Terengganu",
      value: "Terengganu",
      coord: "4.749954742,102.7162113",
    },
    {
      label: "Sabah",
      value: "Sabah",
      coord: "5.311541,117.0942087",
    },
    {
      label: "Sarawak",
      value: "Sarawak",
      coord: "2.292803874,112.8791199",
    },
  ],
  
  // Singapore regions
  SG: [
    {
      label: "Central",
      value: "Central",
      coord: "1.290453,103.851959",
    },
    {
      label: "East",
      value: "East",
      coord: "1.343701,103.953359",
    },
    {
      label: "North",
      value: "North",
      coord: "1.413587,103.835024",
    },
    {
      label: "Northeast",
      value: "Northeast",
      coord: "1.381098,103.886098",
    },
    {
      label: "West",
      value: "West",
      coord: "1.347695,103.686995",
    },
  ],
  
  // Philippines major regions/provinces
  PH: [
    {
      label: "Metro Manila",
      value: "Metro Manila",
      coord: "14.5995,120.9842",
    },
    {
      label: "Cebu",
      value: "Cebu",
      coord: "10.3157,123.8854",
    },
    {
      label: "Davao",
      value: "Davao",
      coord: "7.1907,125.4553",
    },
    {
      label: "Baguio",
      value: "Baguio",
      coord: "16.4023,120.5960",
    },
    {
      label: "Cagayan de Oro",
      value: "Cagayan de Oro",
      coord: "8.4822,124.6467",
    },
    {
      label: "Iloilo",
      value: "Iloilo",
      coord: "10.7202,122.5621",
    },
    {
      label: "Bacolod",
      value: "Bacolod",
      coord: "10.6407,122.9688",
    },
    {
      label: "Batangas",
      value: "Batangas",
      coord: "13.7565,121.0583",
    },
    {
      label: "Pampanga",
      value: "Pampanga",
      coord: "15.0794,120.6200",
    },
    {
      label: "Laguna",
      value: "Laguna",
      coord: "14.2691,121.4113",
    },
    {
      label: "Cavite",
      value: "Cavite",
      coord: "14.4791,120.8970",
    },
    {
      label: "Bulacan",
      value: "Bulacan",
      coord: "14.8527,120.8160",
    },
    {
      label: "Rizal",
      value: "Rizal",
      coord: "14.6037,121.3084",
    },
    {
      label: "Quezon",
      value: "Quezon",
      coord: "14.0669,121.6169",
    },
    {
      label: "Zamboanga",
      value: "Zamboanga",
      coord: "6.9214,122.0790",
    },
  ],
  
  // Indonesia provinces (all 38)
  ID: [
    {
      label: "DKI Jakarta",
      value: "DKI Jakarta",
      coord: "-6.208763,106.845599",
    },
    {
      label: "Jawa Barat",
      value: "Jawa Barat",
      coord: "-6.914894,107.609810",
    },
    {
      label: "Jawa Tengah",
      value: "Jawa Tengah",
      coord: "-7.025253,110.445809",
    },
    {
      label: "Jawa Timur",
      value: "Jawa Timur",
      coord: "-7.536064,112.238402",
    },
    {
      label: "DI Yogyakarta",
      value: "DI Yogyakarta",
      coord: "-7.795580,110.369490",
    },
    {
      label: "Banten",
      value: "Banten",
      coord: "-6.405817,106.064018",
    },
    {
      label: "Sumatera Utara",
      value: "Sumatera Utara",
      coord: "3.597031,98.678513",
    },
    {
      label: "Sumatera Barat",
      value: "Sumatera Barat",
      coord: "-0.947083,100.417181",
    },
    {
      label: "Sumatera Selatan",
      value: "Sumatera Selatan",
      coord: "-2.991442,104.756554",
    },
    {
      label: "Riau",
      value: "Riau",
      coord: "0.507068,101.447777",
    },
    {
      label: "Kepulauan Riau",
      value: "Kepulauan Riau",
      coord: "0.153754,104.580376",
    },
    {
      label: "Jambi",
      value: "Jambi",
      coord: "-1.596672,103.615799",
    },
    {
      label: "Lampung",
      value: "Lampung",
      coord: "-5.450000,105.266670",
    },
    {
      label: "Bengkulu",
      value: "Bengkulu",
      coord: "-3.792855,102.260802",
    },
    {
      label: "Bangka Belitung",
      value: "Bangka Belitung",
      coord: "-2.133333,106.116667",
    },
    {
      label: "Aceh",
      value: "Aceh",
      coord: "5.548290,95.323753",
    },
    {
      label: "Kalimantan Barat",
      value: "Kalimantan Barat",
      coord: "-0.022523,109.330307",
    },
    {
      label: "Kalimantan Tengah",
      value: "Kalimantan Tengah",
      coord: "-2.210000,113.920000",
    },
    {
      label: "Kalimantan Selatan",
      value: "Kalimantan Selatan",
      coord: "-3.319537,114.594376",
    },
    {
      label: "Kalimantan Timur",
      value: "Kalimantan Timur",
      coord: "-0.502106,117.153709",
    },
    {
      label: "Kalimantan Utara",
      value: "Kalimantan Utara",
      coord: "3.073000,117.638000",
    },
    {
      label: "Sulawesi Utara",
      value: "Sulawesi Utara",
      coord: "1.493050,124.841068",
    },
    {
      label: "Sulawesi Tengah",
      value: "Sulawesi Tengah",
      coord: "-0.898583,119.870775",
    },
    {
      label: "Sulawesi Selatan",
      value: "Sulawesi Selatan",
      coord: "-5.147665,119.432732",
    },
    {
      label: "Sulawesi Tenggara",
      value: "Sulawesi Tenggara",
      coord: "-3.967570,122.594720",
    },
    {
      label: "Sulawesi Barat",
      value: "Sulawesi Barat",
      coord: "-2.497450,119.390500",
    },
    {
      label: "Gorontalo",
      value: "Gorontalo",
      coord: "0.544230,123.058760",
    },
    {
      label: "Maluku",
      value: "Maluku",
      coord: "-3.696950,128.180830",
    },
    {
      label: "Maluku Utara",
      value: "Maluku Utara",
      coord: "0.787030,127.380750",
    },
    {
      label: "Bali",
      value: "Bali",
      coord: "-8.340539,115.091951",
    },
    {
      label: "Nusa Tenggara Barat",
      value: "Nusa Tenggara Barat",
      coord: "-8.583333,116.116667",
    },
    {
      label: "Nusa Tenggara Timur",
      value: "Nusa Tenggara Timur",
      coord: "-10.178300,123.607900",
    },
    {
      label: "Papua",
      value: "Papua",
      coord: "-2.533000,140.717000",
    },
    {
      label: "Papua Barat",
      value: "Papua Barat",
      coord: "-0.870000,131.250000",
    },
    {
      label: "Papua Tengah",
      value: "Papua Tengah",
      coord: "-3.368950,138.673530",
    },
    {
      label: "Papua Pegunungan",
      value: "Papua Pegunungan",
      coord: "-4.083330,138.916670",
    },
    {
      label: "Papua Selatan",
      value: "Papua Selatan",
      coord: "-8.000000,140.633330",
    },
    {
      label: "Papua Barat Daya",
      value: "Papua Barat Daya",
      coord: "-1.183000,131.900000",
    },
  ],
};

// Helper function to get states by country
export const getStatesByCountry = (countryCode) => {
  return statesByCountry[countryCode] || statesByCountry.MY;
};

// Export default for backward compatibility
export default statesByCountry.MY;